import React, { createContext, useContext } from 'react';

const AdminLayoutContext = createContext(null);

export const AdminLayoutProvider = ({ children }) => {
  const [showAddCourseModal, setShowAddCourseModal] = React.useState(false);

  const openAddCourseModal = () => setShowAddCourseModal(true);
  const closeAddCourseModal = () => setShowAddCourseModal(false);

  return (
    <AdminLayoutContext.Provider value={{ showAddCourseModal, openAddCourseModal, closeAddCourseModal }}>
      {children}
    </AdminLayoutContext.Provider>
  );
};

export const useAdminLayout = () => useContext(AdminLayoutContext); 